// import { useEffect, useState } from "react";
// import PropTypes from "prop-types";

// // @mui components
// import Card from "@mui/material/Card";
// import Grid from "@mui/material/Grid";

// // Soft UI components
// import SoftBox from "components/SoftBox";
// import SoftTypography from "components/SoftTypography";
// import FormField from "layouts/pages/account/components/FormField";
// import SoftButton from "components/SoftButton";

// import { useParams } from "react-router-dom";
// import { API_URL } from "config";
// import { useAuth } from "AuthContext";
// import { useMemo } from "react";


// const educationLevels = ["tenth", "twelth", "graduation", "post_graduation"];

// const levelKeyMap = {
//   tenth: "Tenth",
//   twelth: "Twelfth",
//   graduation: "Graduation",
//   "post_graduation": "PostGraduation",
// };


// function FresherForm({ value = {}, onChange, onUpdate, loading, setLoading }) {
//   /* ================= PERMISSIONS ================= */
//   const { permissions: ctxPerms = [] } = useAuth();

//   const storedPerms = useMemo(() => {
//     try {
//       return JSON.parse(localStorage.getItem("permissions") || "[]");
//     } catch {
//       return [];
//     }
//   }, []);

//   const permSet = useMemo(() => {
//     const perms = ctxPerms.length ? ctxPerms : storedPerms;
//     return new Set(perms.map(p => (typeof p === "string" ? p : p.name)));
//   }, [ctxPerms, storedPerms]);

//   const canSection = permSet.has("UserProfile.EducationalDetails");

//   const canEdu = (level, field) =>
//     permSet.has(`UserProfile.EducationalDetails.${level}.${field}`);


//   const id = useParams();

//   const [formData, setFormData] = useState({ ...value });

//   console.log("edu", formData);

//   useEffect(() => {
//     setFormData({ ...value });
//   }, [value]);

//   const handleInputChange = (key, inputValue) => {
//     setFormData((prev) => {
//       const updated = { ...prev, [key]: inputValue };
//       onChange && onChange(updated);
//       return updated;
//     });
//   };

//   return (
  

//     <Card id="educational-details" className="p-4">
//       <SoftBox mb={3}>
//         <SoftTypography variant="h5">Educational Details</SoftTypography>
//       </SoftBox>

//       {educationLevels.map((level, index) => {
//         const levelKey = levelKeyMap[level];
//         const board = `${level}_board`;
//         const examPassed = `${level}_exam_passed`;
//         const instituteName = `${level}_institution_name`;
//         const percentage = `${level}_percentage`;
//         const subject = `${level}_subject`;
//         const yearOfPassing = `${level}_year_of_passing`;
//         const mode = `${level}_mode`;

//         if (!canSection) {
//           return null;
//         }

//         return (
//           <div key={index} className="">
//             <SoftTypography
//               variant="h6"
//               fontWeight="bold"
//               color="text"
//               className="text-uppercase mb-1"
//             >
//               {level} Details
//             </SoftTypography>

//             <div className="container-fluid">
//               <div className="row mb-3">
//                 <div className="col-md-6 mb-3">
//                   {canEdu(levelKey, "ExamPassed") && (
//                     <FormField
//                       label="Exam Passed"
//                       placeholder={level}
//                       value={formData?.[examPassed] || ""}
//                       onChange={(e) => handleInputChange(examPassed, e.target.value)}
//                     />
//                   )}
//                 </div>
//                 <div className="col-md-6 mb-3">
//                   {canEdu(levelKey, "Board") && (
//                     <FormField
//                       label="Board / University"
//                       placeholder="Board/University"
//                       value={formData?.[board] || ""}
//                       onChange={(e) => handleInputChange(board, e.target.value)}
//                     />
//                   )}
//                 </div>
//                 <div className="col-md-6 mb-3">
//                   {canEdu(levelKey, "Institution") && (
//                     <FormField
//                       label="Institution Name"
//                       placeholder="Your Institution Name"
//                       value={formData?.[instituteName] || ""}
//                       onChange={(e) => handleInputChange(instituteName, e.target.value)}
//                     />
//                   )}
//                 </div>
//                 <div className="col-md-6 mb-3">
//                   {canEdu(levelKey, "YearOfPassing") && (
//                     <FormField
//                       label="Year of Passing"
//                       placeholder="Year of Passing"
//                       value={formData?.[yearOfPassing] || ""}
//                       onChange={(e) => handleInputChange(yearOfPassing, e.target.value)}
//                     />
//                   )}
//                 </div>
//                 <div className="col-md-6 mb-3">
//                   {canEdu(levelKey, "Percentage") && (
//                     <FormField
//                       label="Percentage/CGPA"
//                       placeholder="Percentage/CGPA"
//                       value={formData?.[percentage] || ""}
//                       onChange={(e) => handleInputChange(percentage, e.target.value)}
//                     />
//                   )}
//                 </div>
//                 <div className="col-md-6 mb-3">
//                   {canEdu(levelKey, "Subject") && (
//                     <FormField
//                       label="Subject/Stream"
//                       placeholder="Subject/Stream"
//                       value={formData?.[subject] || ""}
//                       onChange={(e) => handleInputChange(subject, e.target.value)}
//                     />
//                   )}
//                 </div>
//                 <div className="col-md-6 mb-3">
//                   {canEdu(levelKey, "Mode") && (
//                     <FormField
//                       label="Mode"
//                       placeholder="Mode (Full-time / Part-time)"
//                       value={formData?.[mode] || ""}
//                       onChange={(e) => handleInputChange(mode, e.target.value)}
//                     />
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//         );
//       })}

//       <div className="d-flex justify-content-end mt-3">
//         {permSet.has("UserProfile.EducationalDetails.Save") && (
//           <SoftButton
//             disabled={loading?.updating || !value?.is_educationaldetails}
//             color="info"
//             size="medium"
//             onClick={() => {
//               setLoading(false);
//               onUpdate();
//             }}
//           >
//             {loading ? "Saving..." : "Save"}
//           </SoftButton>
//         )}
//       </div>
//     </Card>
//   );
// }

// FresherForm.propTypes = {
//   value: PropTypes.object,
//   onChange: PropTypes.func,
//   onUpdate: PropTypes.func,
//   loading: PropTypes.func,
//   setLoading: PropTypes.func,
// };

// export default FresherForm;


import { useEffect, useState } from "react";
import PropTypes from "prop-types";

// @mui components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Soft UI components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import FormField from "layouts/pages/account/components/FormField";
import SoftButton from "components/SoftButton";

import { useParams } from "react-router-dom";
import { API_URL } from "config";
import { useAuth } from "AuthContext";
import { useMemo } from "react";

// Import Dialog components from MUI
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
} from "@mui/material";

const educationLevels = ["tenth", "twelth", "graduation", "post_graduation"];

const levelKeyMap = {
  tenth: "Tenth",
  twelth: "Twelfth",
  graduation: "Graduation",
  "post_graduation": "PostGraduation",
};


function FresherForm({ value = {}, onChange, onUpdate, loading, setLoading, onNotify }) {
  /* ================= PERMISSIONS ================= */
  const { permissions: ctxPerms = [] } = useAuth();
  const [educationErrors, setEducationErrors] = useState([]);
const validateEducation = () => {
  const errors = [];

  // ===== 10th =====
  if (!formData.tenth_board) errors.push("10th Board");
  if (!formData.tenth_institution_name) errors.push("10th Institution Name");
  if (!formData.tenth_year_of_passing) errors.push("10th Passing Year");
  if (!formData.tenth_percentage) errors.push("10th Percentage");

  // ===== 12th =====
  if (!formData.twelth_board) errors.push("12th Board");
  if (!formData.twelth_institution_name) errors.push("12th Institution Name");
  if (!formData.twelth_year_of_passing) errors.push("12th Passing Year");
  if (!formData.twelth_percentage) errors.push("12th Percentage");

  return errors;
};


  const storedPerms = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("permissions") || "[]");
    } catch {
      return [];
    }
  }, []);

  const permSet = useMemo(() => {
    const perms = ctxPerms.length ? ctxPerms : storedPerms;
    return new Set(perms.map(p => (typeof p === "string" ? p : p.name)));
  }, [ctxPerms, storedPerms]);

  const canSection = permSet.has("UserProfile.EducationalDetails");

  const canEdu = (level, field) =>
    permSet.has(`UserProfile.EducationalDetails.${level}.${field}`);

  const id = useParams();

  const [formData, setFormData] = useState({ ...value });
  
  // Confirmation Dialog State
  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    title: "Confirm Save",
    message: "Are you sure you want to save the educational details?",
  });

  console.log("edu", formData);

  useEffect(() => {
    setFormData({ ...value });
  }, [value]);

  const handleInputChange = (key, inputValue) => {
    setFormData((prev) => {
      const updated = { ...prev, [key]: inputValue };
      onChange && onChange(updated);
      return updated;
    });
  };

  // Show confirmation dialog
  const showConfirmationDialog = () => {
      const errors = validateEducation();

  if (errors.length > 0) {
    setEducationErrors(errors);
    onNotify?.(`Please fill the following required fields: ${errors.join(", ")}`, "warning");
    return; // ❌ dialog open nahi hoga
  }

    setConfirmDialog({
      open: true,
      title: "Confirm Save",
      message: "Are you sure you want to save the educational details? This will update all educational information.",
    });
  };

  // Handle cancel action
  const handleCancelSave = () => {
    setConfirmDialog({ ...confirmDialog, open: false });
  };

  // Handle confirm save
  const handleConfirmSave = () => {
    setConfirmDialog({ ...confirmDialog, open: false });
    setLoading(false);
    onUpdate();
  };

  return (
    <Card id="educational-details" className="p-4">
      <SoftBox mb={3}>
        <SoftTypography variant="h5">Educational Details</SoftTypography>
      </SoftBox>

      {educationLevels.map((level, index) => {
        const levelKey = levelKeyMap[level];
        const board = `${level}_board`;
        const examPassed = `${level}_exam_passed`;
        const instituteName = `${level}_institution_name`;
        const percentage = `${level}_percentage`;
        const subject = `${level}_subject`;
        const yearOfPassing = `${level}_year_of_passing`;
        const mode = `${level}_mode`;

        if (!canSection) {
          return null;
        }

        return (
          <div key={index} className="">
            <SoftTypography
              variant="h6"
              fontWeight="bold"
              color="text"
              className="text-uppercase mb-1"
            >
              {level} Details
            </SoftTypography>

            <div className="container-fluid">
              <div className="row mb-3">
                <div className="col-md-6 mb-3">
                  {canEdu(levelKey, "ExamPassed") && (
                    <FormField
                      label="Exam Passed"
                      placeholder={level}
                      value={formData?.[examPassed] || ""}
                      onChange={(e) => handleInputChange(examPassed, e.target.value)}
                    />
                  )}
                </div>
                <div className="col-md-6 mb-3">
                  {canEdu(levelKey, "Board") && (
                    <FormField
                      label="Board / University"
                      placeholder="Board/University"
                      value={formData?.[board] || ""}
                      onChange={(e) => handleInputChange(board, e.target.value)}
                    />
                  )}
                </div>
                <div className="col-md-6 mb-3">
                  {canEdu(levelKey, "Institution") && (
                    <FormField
                      label="Institution Name"
                      placeholder="Your Institution Name"
                      value={formData?.[instituteName] || ""}
                      onChange={(e) => handleInputChange(instituteName, e.target.value)}
                    />
                  )}
                </div>
                <div className="col-md-6 mb-3">
                  {canEdu(levelKey, "YearOfPassing") && (
                    <FormField
                      label="Year of Passing"
                      placeholder="Year of Passing"
                      value={formData?.[yearOfPassing] || ""}
                      onChange={(e) => handleInputChange(yearOfPassing, e.target.value)}
                    />
                  )}
                </div>
                <div className="col-md-6 mb-3">
                  {canEdu(levelKey, "Percentage") && (
                    <FormField
                      label="Percentage/CGPA"
                      placeholder="Percentage/CGPA"
                      value={formData?.[percentage] || ""}
                      onChange={(e) => handleInputChange(percentage, e.target.value)}
                    />
                  )}
                </div>
                <div className="col-md-6 mb-3">
                  {canEdu(levelKey, "Subject") && (
                    <FormField
                      label="Subject/Stream"
                      placeholder="Subject/Stream"
                      value={formData?.[subject] || ""}
                      onChange={(e) => handleInputChange(subject, e.target.value)}
                    />
                  )}
                </div>
                <div className="col-md-6 mb-3">
                  {canEdu(levelKey, "Mode") && (
                    <FormField
                      label="Mode"
                      placeholder="Mode (Full-time / Part-time)"
                      value={formData?.[mode] || ""}
                      onChange={(e) => handleInputChange(mode, e.target.value)}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      })}

      {educationErrors.length > 0 && (
  <div
    style={{
      background: "#fff4f4",
      border: "1px solid #f5c2c7",
      color: "#842029",
      padding: "10px 14px",
      borderRadius: "6px",
      marginBottom: "12px",
      fontSize: "13px",
    }}
  >
    <strong>Please fill the following required fields:</strong>
    <ul style={{ margin: "6px 0 0 18px" }}>
      {educationErrors.map((field, index) => (
        <li key={index}>{field}</li>
      ))}
    </ul>
  </div>
)}


      <div className="d-flex justify-content-end mt-3">
        {permSet.has("UserProfile.EducationalDetails.Save") && (
          <SoftButton
            disabled={loading?.updating || !value?.is_educationaldetails}
            color="info"
            size="medium"
            variant="gradient"
            onClick={showConfirmationDialog}
          >
            {loading ? "Saving..." : "Save"}
          </SoftButton>
        )}
      </div>

      {/* Confirmation Dialog */}
      <Dialog
        open={confirmDialog.open}
        onClose={handleCancelSave}
        aria-labelledby="confirmation-dialog-title"
        aria-describedby="confirmation-dialog-description"
      >
        <DialogTitle id="confirmation-dialog-title">
          {confirmDialog.title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="confirmation-dialog-description">
            {confirmDialog.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <SoftButton 
            onClick={handleCancelSave} 
            color="secondary"
            variant="outlined"
            size="small"
          >
            Cancel
          </SoftButton>
          <SoftButton 
            onClick={handleConfirmSave} 
            color="info"
            variant="gradient"
            size="small"
            autoFocus
            disabled={loading?.updating || !value?.is_educationaldetails}
          >
            {loading ? "Saving..." : "Confirm Save"}
          </SoftButton>
        </DialogActions>
      </Dialog>
    </Card>
  );
}

FresherForm.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func,
  onUpdate: PropTypes.func,
  loading: PropTypes.func,
  setLoading: PropTypes.func,
  onNotify: PropTypes.func,
};

export default FresherForm;
